import type { AtsiStatus, Sex, Student } from '@/types';

export type SexFilter = Sex | 'all';
export type AtsiFilter = AtsiStatus | 'all';
export type LboteFilter = 'all' | 'lbote' | 'non_lbote';

export interface DemographicFilters {
  sex: SexFilter;
  atsi: AtsiFilter;
  lbote: LboteFilter;
}

export const NO_DEMOGRAPHIC_FILTERS: DemographicFilters = {
  sex: 'all',
  atsi: 'all',
  lbote: 'all',
};

export function isDemographicFilterActive(f: DemographicFilters): boolean {
  return f.sex !== 'all' || f.atsi !== 'all' || f.lbote !== 'all';
}

export function makeDemographicPredicate(f: DemographicFilters): (s: Student) => boolean {
  return (s) => {
    if (f.sex !== 'all' && s.sex !== f.sex) return false;
    if (f.atsi !== 'all' && s.atsi !== f.atsi) return false;
    if (f.lbote === 'lbote' && s.isLbote !== true) return false;
    if (f.lbote === 'non_lbote' && s.isLbote !== false) return false;
    return true;
  };
}
